export const QuestionType = {
  None: 0,
  MultiSelect: 1,
  RadioSelect: 2,
  RadioSelectMulti: 3,
  FreemformTextShort: 4,
  FreeformTextLong: 5,
  NumericText: 6,
  RatingStars: 7,
  Slider: 8,
  Date: 9,
  DateTime: 10,
  FileUpload: 11,
  NetPromoter: 12,
  TextLabel: 13,
  EmployeeSelection: 14,
  Signature: 15,
  ClientSelection: 16,
  ClientSiteSelection: 17,
  DrugAndAlcoholSelection: 18,
  PPESelection: 19,
  Time: 20,
  AffiliatedOffice: 21,
} as const;

export type QuestionType = (typeof QuestionType)[keyof typeof QuestionType];

export type FormQuestion = {
  QuestionIndex: number;
  Key: string;
  BranchingInfo: BranchingInfo[];
  BranchedQuestion: boolean;
  QuestionAnswerTypeEnum: QuestionType;
  QuestionAnswerConfigOptionDetails: QuestionConfig;
  QuestionAnswerRequired: boolean;
  QuestionLink: string;
  QuestionFull: string;
  QuestionDescription: string;
  QuestionAnswerConfigOptions: QuestionAnswerConfigOption[];
  QuestionAnswerConfigHeaderOptions: any[];
  Hidden: boolean;
  Answered: boolean;
};

export type QuestionAnswerConfigOption = {
  AnswerOptionName: string;
  AnswerOptionValue: string;
  AnswerQuestionKey: string;
  Key: string;
  ActualAnswerValue: string;
  Active: boolean;
};

export type QuestionConfig = {
  AnswerMinimumValue: number;
  AnswerMaximumValue: number;
  AnswerStepValue: number;
};

export type BranchingInfo = {
  Key: string;
  Active: boolean;
  AnswerOptionKey: string;
  AnswerOptionName: string;
  AnswerOptionValue: number;
  BranchedQuestionKey: string;
  BranchOptionKey: string;
  FormAssignmentQuestionKey: string;
  MasterFormKey: string;
  MasterQuestionKey: string;
};
